import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	ArchivedFilterEnum,
	getPropertyV2,
	type PortfolioReportingOverviewTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type Options = {
	filterDatagroups?: PortfolioReportingOverviewTypeEnum[];
	onlyReportingEnabled?: boolean;
	archived?: ArchivedFilterEnum;
	enabled?: boolean;
};

export const usePropertyListQuery = ({
	filterDatagroups,
	onlyReportingEnabled,
	// TODO: the portfolio list should pass the user-selected archived filter once FE archiving is done
	archived = ArchivedFilterEnum.All,
	enabled = true,
}: Options = {}) => {
	return useQuery({
		queryKey: PortfolioKeys.propertyList(
			filterDatagroups,
			onlyReportingEnabled,
			archived,
		),
		queryFn: ({ signal }) =>
			processResponse(() =>
				getPropertyV2(filterDatagroups, onlyReportingEnabled, archived, {
					signal,
				}),
			)(undefined),
		enabled,
	});
};
